import selectionZSJPng from '../../static/YearMiddleReport2024/report/selectionZSJ.png'
import selectionCSJPng from '../../static/YearMiddleReport2024/report/selectionCSJ.png'


export const yearMiddle2024 = [
  {
    regionId: 'rmu45dtzl84fk',
    regionName: '长三角城市群',
    originalPrice: 199,//,
    fanPrice: 99,//49, //铁粉价格（拼团价格）
    topics: [],
    coverImage: selectionCSJPng,
    sellingpPoint: '逆袭、掉队、流量密码、大单'
  },
  {
    regionId: '2mgv1a7tq8xgm',
    regionName: '珠三角城市群',
    originalPrice: 199,//79,
    fanPrice: 99,// 59,  //铁粉价格（拼团价格）
    topics: [],
    coverImage: selectionZSJPng,
    sellingpPoint: '垫底、千万供应、去化法宝、跨境电商'
  },
]
